import React from "react";
import moment from "moment";

class ReportCardSaveds extends React.Component {
  render() {
    const {data, user} = this.props;
    let hoy = new Date();
    var Hora = hoy.getHours();
    var Min = hoy.getMinutes();
    var Fecha = hoy.toLocaleDateString();

    if(data.length === 0){
    return (
        <div></div>
    );
    }
    return (
      <div>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width: '50px',visibility:'hidden'}}><p>Oculto</p></th>
            <th style={{width: '50px',textAlign:'center', paddingTop:'70px'}}>
              <img style={{width: '100%', height:'auto'}} src="https://rintisa.com.pe/images/logo.svg" />
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%'}}>
          <thead>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{textAlign:'center'}}>
              <h2 style={{fontWeight:'bold'}}>AUTOGESTIÓN CLIENTES "CARRITOS GUARDADOS"</h2>
            </th>
            <th style={{visibility:'hidden'}}>a</th>
          </thead>
        </table>
        <br></br>  
        <table style={{width: '100%'}}>
          <thead>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>            
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>Pedidos: {data.length}</h3>
            </th>
            <th style={{textAlign:'center'}}>
                <h3 style={{fontWeight:'bold'}}>{Fecha}-{Hora}:{Min}hs</h3>
            </th>
            <th style={{width:' 50px',visibility:'hidden'}}><p>Oculto</p></th>
          </thead>
        </table>
        <br></br>
        <table style={{width: '100%', borderCollapse: 'collapse'}}>
          <tr style={{backgroundColor:'#0078C0',paddingTop: '12px', paddingBottom: '12px', textAlign: 'left', color: 'white'}}>
            <th style={{visibility:'hidden'}}>a</th>
            <th style={{textAlign:'center'}}>#</th>
            <th style={{textAlign:'center'}}>Fecha</th>
            <th style={{textAlign:'center'}}>Cliente</th>
            <th style={{textAlign:'left'}}>Nombre</th>            
            <th style={{textAlign:'center'}}>Zona</th>
            <th style={{textAlign:'left'}}>Dirección de envío</th>
            <th style={{textAlign:'center'}}>Peso neto</th>
            <th style={{textAlign:'center'}}>Precio total</th>           
            <th style={{visibility:'hidden'}}>a</th>
          </tr>
          {!!data && data.map((item, index) => {
            return (
                  <tr>
                    <th style={{visibility:'hidden'}}>a</th>
                    <th style={{textAlign:'center', fontSize:11}}>{index+1}</th>
                    <th style={{textAlign:'center', fontSize:11}}>{moment(item.DateCart).format('DD-MM-YYYY')}</th>
                    <th style={{textAlign:'center', fontSize:11}}>{item.CardCode}</th>
                    <th style={{textAlign:'left', fontSize:11}}>{item.CardName}</th>                                          
                    <th style={{textAlign:'center', fontSize:11}}>{item.Zona}</th>
                    <th style={{textAlign:'left', fontSize:11}}>{item.DirEnvio}</th> 
                    <th style={{textAlign:'center', fontSize:11}}>{parseFloat(item.PesoNeto > 0 ? item.PesoNeto : 0).toFixed(2) + ' KG' }</th>
                    <th style={{textAlign:'center', fontSize:11}}>S/{parseFloat(item.Valor > 0 ? item.Valor : 0).toFixed(2)}</th>
                    <th style={{visibility:'hidden'}}>a</th>
                  </tr> 
                );
            })
          }              
        </table>    
        <br></br>                
      </div>
    );
  }
}

export default ReportCardSaveds;